import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { 
    ADD_NEW_UPLOAD_DATA_TOPIC_ACTION_TYPE ,
    ADD_NEW_KEYWORD_TOPIC_ACTION_TYPE
} from '../redux/constants';
import {
    KEYWORD_FILTERING_TOPIC_MODAL_STATE,
    UPLOAD_DATA_TOPIC_DETAILS_MODAL_STATE
} from './constants/constants';
import { t } from 'i18next';
import { 
    CHOOSE_DATA_SOURCE_MODAL_I18N_KEYS as MY_I18N_KEYS, 
    CHOOSE_DATA_SOURCE_MODAL_I18N_PREFIX as MY_I18N_PREFIX 
} from './constants/i18n/ChooseDataSourceModali18nConstants';

class ChooseDataSourceModal extends Component {

    static propTypes = {
        show:                     PropTypes.bool.isRequired,
        toggleModal:              PropTypes.oneOfType([PropTypes.bool,PropTypes.func]).isRequired,
        changeModalState:         PropTypes.func.isRequired,
        changeAddTopicActionType: PropTypes.func.isRequired
    };
    
    getI18nAbsoluteKey(relativeKey) {
        return MY_I18N_PREFIX + "." + relativeKey;
      }
    
    getI18nText(relativeKey) {
    const absoluteKey = this.getI18nAbsoluteKey(relativeKey);
    return t(absoluteKey);
    }
    
    setKeywordFilteringAsNewTopicDataSource() {
        this.props.changeAddTopicActionType(ADD_NEW_KEYWORD_TOPIC_ACTION_TYPE);
        this.props.changeModalState(KEYWORD_FILTERING_TOPIC_MODAL_STATE);
    }
    
    setUploadedDataAsNewTopicDataSource() {
        this.props.changeAddTopicActionType(ADD_NEW_UPLOAD_DATA_TOPIC_ACTION_TYPE);
        this.props.changeModalState(UPLOAD_DATA_TOPIC_DETAILS_MODAL_STATE);
    }

    render() {
        const {
            show,
            toggleModal
        } = this.props;
        return (
            <div className={`modal choose-data-source-modal ${show ? 'modal-show' : 'modal-hide'}`}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-content">
                            <div className="modal-header">
                                <div className="modal-header-text">
                                    <span className="getting-started-title">
                                        {this.getI18nText(MY_I18N_KEYS.getting_started_title)}
                                    </span>
                                    <span className="modal-prompt">
                                        {this.getI18nText(MY_I18N_KEYS.getting_started_prompt)}
                                    </span>
                                </div>
                                <button
                                    onClick={() => toggleModal(false)}
                                    onKeyDown={() => {}}
                                >
                                    <i className="la la-close modal-close"  />    
                                </button>
                            </div>
                            <div className='data-source-body'>
                                <div
                                    className='data-source-option keyword-filtering-option'
                                    onClick={() => this.setKeywordFilteringAsNewTopicDataSource()}
                                >
                                    <i className="las la-comments"></i>
                                    <span>{this.getI18nText(MY_I18N_KEYS.keyword_filtering_button_text)}</span>
                                </div>
                                <div
                                    className='data-source-option upload-data-option'
                                    onClick={() => this.setUploadedDataAsNewTopicDataSource()}
                                >
                                    <i className="las la-cloud-upload-alt"></i>
                                    <span>{this.getI18nText(MY_I18N_KEYS.upload_data_button_text)}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ChooseDataSourceModal;


// WEBPACK FOOTER //
// ./src/features/topics/components/ChooseDataSourceModal.js